import React from "react";
import { Alert, Typography } from "@material-tailwind/react";
import { AlertColors, AlertTypes } from "../../../models/Enums";
import useGlobalState from "../../../context/GlobalState";
import "./GlobalAlert.css"
import useIsMobile from "../../../hooks/useIsMobile";


const GlobalAlert = () => {
    let { message, type } = useGlobalState(state => state.alert);
    let showAlert = useGlobalState(state => state.showAlert);
    const clearAlert = useGlobalState(state => state.clearAlert);
    const isMobile = useIsMobile();

    const SuccesIcon = () => {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="h-6 w-6"
            >
                <path
                    fillRule="evenodd"
                    d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z"
                    clipRule="evenodd"
                />
            </svg>
        );
    }

    const WarningIcon = () => {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="h-6 w-6"
            >
                <path
                    fillRule="evenodd"
                    d="M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z"
                    clipRule="evenodd"
                />
            </svg>
        );
    }

    const InfoIcon = () => {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2}
                stroke="currentColor"
                className="h-6 w-6"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
                />
            </svg>
        );
    }

    const getColor = (type: number) => {
        switch (type) {
            case AlertTypes.SUCCESS:
                return AlertColors.SUCCESS;
            case AlertTypes.ERROR:
                return AlertColors.ERROR;
            case AlertTypes.WARNING:
                return AlertColors.WARNING;
            case AlertTypes.INFO:
                return AlertColors.INFO;
            default:
                return AlertColors.INFO;
        }
    }

    const getIcon = (type: number) => {
        switch (type) {
            case AlertTypes.SUCCESS:
                return <SuccesIcon />;
            case AlertTypes.ERROR:
                return <WarningIcon />;
            case AlertTypes.WARNING:
                return <WarningIcon />;
            case AlertTypes.INFO:
                return <InfoIcon />;
            default:
                return <InfoIcon />;
        }
    }

    const getTitle = () => {
        switch (type) {
            case AlertTypes.SUCCESS:
                return "Success";
            case AlertTypes.ERROR:
                return "Error";
            case AlertTypes.WARNING:
                return "Warning";
            case AlertTypes.INFO:
                return "Info";
            default:
                return "Info";
        }
    }

    return (
        <div className="global-alert">
            <Alert
                open={showAlert}
                className={"fixed top-5 right-0 z-50 text-white" + (isMobile ? " left-1/2 transform -translate-x-1/2" : "")}
                icon={getIcon(type)}
                onClose={clearAlert}
                animate={isMobile ? {} : {
                    mount: { x: -20, y: 0 },
                    unmount: { x: 400, y: 0 }
                }}
                style={{ width: isMobile ? "98%" : "420px" }}
                color={getColor(type)}

            >
                <Typography variant="h5" color="white" placeholder="">
                    {getTitle()}
                </Typography>
                <Typography variant="h6" color="white" className="mt-2 font-normal" placeholder="">
                    {message}
                </Typography>
            </Alert>
        </div>
    );
}
export default GlobalAlert;